// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".red[data-v-634460e5] {\n  background-color: gray;\n}\n.circular[data-v-634460e5] {\n  border-radius: 50%;\n}", ""]);
// Exports
module.exports = exports;
